(function () {
  'use strict';

  let initAttempts = 0;

  function start() {
    const root = document.querySelector('[data-apn-search]');
    const master = window.APN_MASTER_DATA || [];
    if (!root || !master.length) {
      if (initAttempts < 50) {
        initAttempts += 1;
        window.setTimeout(start, 100);
      }
      return;
    }

    if (root.dataset.apnInitialized === 'true') return;

    const locale = root.dataset.locale === 'en' ? 'en' : 'ja';
    const destinationSelect = root.querySelector('[data-apn-destination]');
    const destinationDropdown = root.querySelector('[data-apn-destination-dropdown]');
    const destinationTrigger = root.querySelector('[data-apn-destination-trigger]');
    const destinationLabel = root.querySelector('[data-apn-destination-label]');
    const destinationMenu = root.querySelector('[data-apn-destination-menu]');
    const destinationSearch = root.querySelector('[data-apn-destination-search]');
    const destinationOptions = root.querySelector('[data-apn-destination-options]');
    const destinationEmpty = root.querySelector('[data-apn-destination-empty]');
    const planSelect = root.querySelector('[data-apn-plan]');
    const submitButton = root.querySelector('[data-apn-submit]');
    const clearButton = root.querySelector('[data-apn-clear]');
    const summary = root.querySelector('[data-apn-summary]');
    const message = root.querySelector('[data-apn-message]');
    const results = root.querySelector('[data-apn-results]');
    const resultsTitle = root.querySelector('[data-apn-results-title]');
    const resultList = root.querySelector('[data-apn-result-list]');
    const moreButton = root.querySelector('[data-apn-more]');
    const resultsTiktokNote = root.querySelector('[data-apn-results-tiktok-note]');
    const requiredElements = [
      destinationSelect, destinationDropdown, destinationTrigger, destinationLabel, destinationMenu,
      destinationSearch, destinationOptions, destinationEmpty, planSelect, submitButton, clearButton,
      summary, message, results, resultsTitle, resultList, moreButton
    ];
    if (requiredElements.some((element) => !element)) {
      if (initAttempts < 50) {
        initAttempts += 1;
        window.setTimeout(start, 100);
      }
      return;
    }

    root.dataset.apnInitialized = 'true';
    const initialLimit = 10;
    let activeRows = [];
    let visibleCount = initialLimit;

    const text = locale === 'en' ? {
      unknown: 'I am not sure', selectPlan: 'Select your purchased plan',
      daily: 'Daily type', total: 'Total type', unlimited: 'Unlimited', results: 'Search results', found: 'results found',
      network: 'Network', reset: 'Daily data refresh time',
      candidates: 'There may be several matching APNs. Please check the plan name shown in your purchase confirmation email.',
      noResults: 'No matching APN was found. Please check your eSIM delivery email or contact customer support.',
      copied: 'Copied', destination: 'Destination', plan: 'Purchased plan', resetHelpLabel: 'About daily data refresh time',
      resetHelpTitle: 'What is the data refresh time?',
      resetHelpBody: 'This is the time when the data allowance for daily plans (e.g. 1GB/day) is refreshed.',
      resetHelpTotal: '※This does not apply to total data plans.',
      resetHelpExpiry: '※This is different from the plan validity period.',
      tiktokNote: 'Some devices may not be able to use TikTok.'
    } : {
      unknown: 'わからない', selectPlan: '購入したプランを選択してください',
      daily: 'デイリータイプ', total: 'トータルタイプ', unlimited: '無制限', results: '検索結果', found: '件見つかりました',
      network: '通信会社', reset: 'デイリー容量の更新時刻',
      candidates: '該当する可能性のあるAPNが複数あります。購入完了メールに記載されているプラン名をご確認ください。',
      noResults: '該当するAPNが見つかりませんでした。eSIM配信メールをご確認いただくか、カスタマーサポートへお問い合わせください。',
      copied: 'コピーしました', destination: '目的地', plan: '購入したプラン', resetHelpLabel: 'デイリー容量の更新時刻について',
      resetHelpTitle: 'データ容量の更新時刻とは？',
      resetHelpBody: 'デイリープラン（例：1日1GB）のデータ容量が更新される時刻です。',
      resetHelpTotal: '※総容量プランには適用されません。',
      resetHelpExpiry: '※プランの有効期限とは異なります。',
      tiktokNote: '一部の端末ではTikTokをご利用いただけない場合があります。'
    };
    const destinationPlaceholder = locale === 'en' ? 'Select a country or region' : '国・地域を選択してください';
    const destinationAliases = {
      'アメリカ・ハワイ': 'アメリカ'
    };
    const destinations = uniqueSorted(master.map((row) => destinationName(row.destination)));

    function normalize(value) {
      return String(value || '').normalize('NFKC').toLowerCase()
        .replace(/\|?\s*e\s*sim.*$/i, '').replace(/[₊+]/g, '').replace(/[&＆]/g, '・')
        .replace(/周遊/g, '').replace(/[ヶか]国/g, '地域').replace(/[\s\-_・|｜/（）()]/g, '');
    }

    function uniqueSorted(values) {
      return Array.from(new Set(values.filter(Boolean))).sort((a, b) => a.localeCompare(b, 'ja'));
    }

    function destinationName(destination) {
      return destinationAliases[destination] || destination;
    }

    function matchesDestination(row) {
      return destinationName(row.destination) === destinationSelect.value;
    }

    function addOption(select, value, label) {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = label;
      select.appendChild(option);
    }

    function renderDestinations(query) {
      const keyword = normalize(query);
      const filtered = destinations.filter((destination) => !keyword || normalize(destination).includes(keyword));
      destinationOptions.innerHTML = '';
      filtered.forEach((destination) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'apn-search-dropdown__option';
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', destinationSelect.value === destination ? 'true' : 'false');
        option.classList.toggle('is-selected', destinationSelect.value === destination);
        option.textContent = destination;
        option.addEventListener('click', () => selectDestination(destination));
        destinationOptions.appendChild(option);
      });
      destinationEmpty.hidden = filtered.length > 0;
    }

    function openDestinationDropdown() {
      destinationMenu.hidden = false;
      destinationDropdown.classList.add('is-open');
      destinationTrigger.setAttribute('aria-expanded', 'true');
      destinationSearch.value = '';
      renderDestinations('');
      window.requestAnimationFrame(() => destinationSearch.focus());
    }

    function closeDestinationDropdown() {
      destinationMenu.hidden = true;
      destinationDropdown.classList.remove('is-open');
      destinationTrigger.setAttribute('aria-expanded', 'false');
    }

    function closeResetHelp(exceptTrigger) {
      root.querySelectorAll('[data-apn-reset-help-trigger]').forEach((trigger) => {
        if (exceptTrigger && trigger === exceptTrigger) return;
        trigger.setAttribute('aria-expanded', 'false');
        const help = trigger.closest('.apn-search-help')?.querySelector('[data-apn-reset-help]');
        if (help) help.hidden = true;
      });
    }

    function toggleResetHelp(trigger) {
      const help = trigger.closest('.apn-search-help')?.querySelector('[data-apn-reset-help]');
      if (!help) return;
      const willOpen = help.hidden;
      closeResetHelp(trigger);
      help.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', String(willOpen));
    }

    function selectDestination(destination) {
      destinationSelect.value = destination;
      destinationLabel.textContent = destination;
      closeDestinationDropdown();
      updatePlans();
    }

    function typeKey(masterType) {
      if (masterType === '無制限') return 'unlimited';
      if (masterType === 'デイリープラン') return 'daily';
      return 'total';
    }

    function typeName(key) {
      return key === 'daily' ? text.daily : key === 'total' ? text.total : text.unlimited;
    }

    function resultKey(row) {
      return [
        row.destination,
        row.plan,
        row.carrier,
        row.apn,
        row.chatgpt,
        String(row.tiktok || '').replace('*', ''),
        row.reset
      ].map((value) => String(value || '').trim()).join('\u001f');
    }

    function deduplicateRows(rows) {
      const seen = new Set();
      return rows.filter((row) => {
        const key = resultKey(row);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    function updatePlans() {
      planSelect.innerHTML = '';
      addOption(planSelect, '', text.selectPlan);
      if (!destinationSelect.value) { planSelect.disabled = true; resetAfterPlan(); return; }
      uniqueSorted(master.filter(matchesDestination).map((row) => row.plan))
        .forEach((plan) => addOption(planSelect, plan, plan));
      addOption(planSelect, '__unknown__', text.unknown);
      planSelect.disabled = false;
      resetAfterPlan();
    }

    function resetAfterPlan() {
      submitButton.disabled = true;
      summary.hidden = true; message.hidden = true; results.hidden = true;
      if (resultsTiktokNote) resultsTiktokNote.hidden = true;
    }

    function updateSearchState() {
      if (!planSelect.value) { resetAfterPlan(); return; }
      submitButton.disabled = false;
      message.hidden = true; results.hidden = true; summary.hidden = true;
      if (resultsTiktokNote) resultsTiktokNote.hidden = true;
    }

    function runSearch() {
      if (!destinationSelect.value || !planSelect.value) return;
      const planUnknown = planSelect.value === '__unknown__';
      activeRows = deduplicateRows(master.filter((row) => {
        if (!matchesDestination(row)) return false;
        if (!planUnknown && row.plan !== planSelect.value) return false;
        return true;
      })).map((row, index) => ({ ...row, _index: index }));
      visibleCount = initialLimit;
      const ambiguous = planUnknown;
      message.hidden = !ambiguous;
      if (ambiguous) message.textContent = text.candidates;
      renderSummary();
      renderRows();
    }

    function renderSummary() {
      const planLabel = planSelect.options[planSelect.selectedIndex].textContent;
      summary.innerHTML = '<strong>' + escapeHtml(destinationSelect.value) + ' × ' + escapeHtml(planLabel) + '</strong>　' + activeRows.length + text.found;
      summary.hidden = false;
    }

    function renderRows() {
      resultList.innerHTML = '';
      if (!activeRows.length) { results.hidden = true; message.textContent = text.noResults; message.hidden = false; return; }
      resultsTitle.textContent = text.results + '（' + activeRows.length + text.found + '）';
      activeRows.slice(0, visibleCount).forEach((row, index) => resultList.appendChild(createRow(row, index)));
      moreButton.hidden = visibleCount >= activeRows.length;
      if (resultsTiktokNote) resultsTiktokNote.hidden = !activeRows.some((row) => String(row.tiktok || '').includes('△'));
      results.hidden = false;
    }

    function createCell(value, label) {
      const cell = document.createElement('td'); cell.dataset.label = label; cell.textContent = value || '—'; return cell;
    }

    function createCarrierCell(row) {
      const cell = document.createElement('td');
      cell.dataset.label = text.network;
      cell.innerHTML = '<span class="apn-search__cell-label">' + escapeHtml(text.network) + '</span>'
        + '<span class="apn-search__carrier-name">' + escapeHtml(row.carrier || '—') + '</span>'
        + '<div class="apn-search__result-meta">'
        + '<span><strong>' + escapeHtml(text.destination) + '：</strong>' + escapeHtml(row.destination || '—') + '</span>'
        + '<span><strong>' + escapeHtml(text.plan) + '：</strong>' + escapeHtml(row.plan || '—') + '</span>'
        + '</div>';
      return cell;
    }

    function createTiktokCell(value) {
      const cell = document.createElement('td');
      const tiktok = String(value || '').replace('*', '');
      cell.dataset.label = 'TikTok';
      if (tiktok.includes('△')) {
        cell.innerHTML = escapeHtml(tiktok) + '<span class="apn-search__tiktok-mark">※</span>';
      } else {
        cell.textContent = tiktok || '—';
      }
      return cell;
    }

    function createResetHelpMarkup(mobile) {
      return '<span class="apn-search-help' + (mobile ? ' apn-search-help--mobile' : '') + '">'
        + '<span>' + escapeHtml(text.reset) + '</span>'
        + '<button type="button" class="apn-search-help__trigger" data-apn-reset-help-trigger aria-expanded="false" aria-label="' + escapeHtml(text.resetHelpLabel) + '">ⓘ</button>'
        + '<span class="apn-search-help__tooltip" data-apn-reset-help role="tooltip" hidden>'
        + '<strong>' + escapeHtml(text.resetHelpTitle) + '</strong>'
        + '<span>' + escapeHtml(text.resetHelpBody) + '</span>'
        + '<span>' + escapeHtml(text.resetHelpTotal) + '</span>'
        + '<span>' + escapeHtml(text.resetHelpExpiry) + '</span>'
        + '</span>'
        + '</span>';
    }

    function createResetCell(value) {
      const cell = document.createElement('td');
      cell.className = 'apn-search__reset-cell';
      cell.dataset.label = text.reset;
      cell.innerHTML = createResetHelpMarkup(true) + '<span class="apn-search__reset-value">' + escapeHtml(value || '—') + '</span>';
      return cell;
    }

    function createRow(row, index) {
      const fragment = document.createDocumentFragment();
      const tr = document.createElement('tr'); tr.className = 'apn-search__result-row';
      tr.appendChild(createCarrierCell(row));
      const apnCell = document.createElement('td'); apnCell.dataset.label = 'APN';
      const copy = document.createElement('button'); copy.type = 'button'; copy.className = 'apn-search__copy'; copy.textContent = row.apn || '—';
      copy.addEventListener('click', () => navigator.clipboard && navigator.clipboard.writeText(row.apn || '').then(() => { const original = copy.textContent; copy.textContent = text.copied; setTimeout(() => { copy.textContent = original; }, 1200); }));
      apnCell.appendChild(copy); tr.appendChild(apnCell);
      tr.appendChild(createCell(row.chatgpt, 'ChatGPT'));
      tr.appendChild(createTiktokCell(row.tiktok));
      tr.appendChild(createResetCell(row.reset));
      fragment.appendChild(tr);
      return fragment;
    }

    function escapeHtml(value) {
      const div = document.createElement('div'); div.textContent = String(value || ''); return div.innerHTML;
    }

    function clearAll() {
      destinationSelect.value = ''; destinationLabel.textContent = destinationPlaceholder; closeDestinationDropdown();
      planSelect.innerHTML = ''; addOption(planSelect, '', text.selectPlan); planSelect.disabled = true;
      resetAfterPlan(); resultList.innerHTML = ''; activeRows = [];
    }

    renderDestinations('');
    destinationTrigger.addEventListener('click', () => destinationMenu.hidden ? openDestinationDropdown() : closeDestinationDropdown());
    destinationSearch.addEventListener('input', () => renderDestinations(destinationSearch.value));
    destinationSearch.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { closeDestinationDropdown(); destinationTrigger.focus(); }
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        const firstOption = destinationOptions.querySelector('.apn-search-dropdown__option');
        if (firstOption) firstOption.focus();
      }
    });
    destinationOptions.addEventListener('keydown', (event) => {
      const options = Array.from(destinationOptions.querySelectorAll('.apn-search-dropdown__option'));
      const currentIndex = options.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' && options[currentIndex + 1]) { event.preventDefault(); options[currentIndex + 1].focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); currentIndex > 0 ? options[currentIndex - 1].focus() : destinationSearch.focus(); }
      if (event.key === 'Escape') { closeDestinationDropdown(); destinationTrigger.focus(); }
    });
    document.addEventListener('click', (event) => {
      if (!destinationDropdown.contains(event.target)) closeDestinationDropdown();
      const resetTrigger = event.target.closest('[data-apn-reset-help-trigger]');
      if (resetTrigger && root.contains(resetTrigger)) {
        toggleResetHelp(resetTrigger);
        return;
      }
      if (!event.target.closest('.apn-search-help')) closeResetHelp();
    });
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeResetHelp(); });
    planSelect.addEventListener('change', updateSearchState);
    submitButton.addEventListener('click', runSearch);
    clearButton.addEventListener('click', clearAll);
    moreButton.addEventListener('click', () => { visibleCount += initialLimit; renderRows(); });

    root.querySelectorAll('[data-apn-setup-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.apnSetupTab;
        root.querySelectorAll('[data-apn-setup-tab]').forEach((button) => {
          const active = button === tab;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-apn-setup-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.apnSetupPanel !== target;
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
